export { default } from "./src/jira-templates-tab-content-subgrid-layout";
